import { render, staticRenderFns } from "./IncidenciasListado.vue?vue&type=template&id=130b4d42&scoped=true"
import script from "./IncidenciasListado.vue?vue&type=script&lang=js"
export * from "./IncidenciasListado.vue?vue&type=script&lang=js"
import style0 from "./IncidenciasListado.vue?vue&type=style&index=0&id=130b4d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b4d42",
  null
  
)

export default component.exports